<div [ngClass]="sentByMe() ? 'outgoing-container' : 'incoming-container'">
	<div class="card-head">
		<au-round-avatar
			[fullName]="commentAuthorName()"
			[smallAvatarUrl]="commentAuthorAvatar()"
			[size]="40"
		/>
	</div>
	<div class="card-body">
		<div class="sent-from">
			{{ commentAuthorName() }}

			<mat-icon class="message-icon" [svgIcon]="'chat-bubble-outline'"></mat-icon>
		</div>
		<div class="comment-info">
			<div class="nice-scroll colored-scroll-track" [class.sent-by-me]="sentByMe()">
				@if (isHtml(comment().text)) {
					<p class="comment" [innerHtml]="comment().text"></p>
				} @else {
					<p class="message" [innerText]="comment().text"></p>
				}
				<div>
					@if (comment().attachment) {
						<mat-icon svgIcon="file-image"></mat-icon>
						<a [href]="comment().attachment.link" target="_blank">{{
							comment().attachment.name
						}}</a>
					}
				</div>
			</div>
		</div>
	</div>
</div>
